import type { SmartFinderResponse } from './types';

/** Classify coverage gaps independently of rolling-deploy response shape. */
export function isIncompleteSearchResponse(data: SmartFinderResponse): boolean {
  const incompleteCode = data.code === 'INCOMPLETE' || data.code === 'PARTIAL';
  if (data.type === 'no_results') {
    return data.complete === false
      || data.retryable === true
      || incompleteCode
      || data.failureCode === 'INCOMPLETE_COVERAGE'
      || Boolean(data.partialCoverage);
  }
  return data.type === 'error'
    && (incompleteCode || data.failureCode === 'INCOMPLETE_COVERAGE');
}

export function classifyEmptySearchAnalytics(
  data: SmartFinderResponse,
): 'search_no_results' | 'search_incomplete' | null {
  if (isIncompleteSearchResponse(data)) return 'search_incomplete';
  if (data.type === 'no_results') return 'search_no_results';
  return null;
}
